import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateAlignerMaterialSchema } from "../schema/updateAlignerMaterialSchema";
import { updatePaymentInformation } from "../../../api/caseApi";
import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Controller } from "react-hook-form";
import { getAllTermsOfPaymentByType } from "../../../api/termsOfPaymentApi";
import { updateCaseTermsOfPayment } from "../../../api/termsOfPaymentApi";
import { updateCaseTermsOfPaymentSchema } from "../schema/updateCaseTermsOfPaymentSchema";
const UpdateCaseTermsOfPaymentDialog = ({
  openUpdateCaseTermsOfPayment,
  handleCloseUpdateCaseTermsOfPayment,
  termsOfPayment1,
  caseId,
  getCaseData,
}) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(updateCaseTermsOfPaymentSchema),
  });

  const [termsOfPayment, setTermsOfPayment] = useState([]);

  useEffect(() => {
    const fetchTerms = async () => {
      const terms = await getAllTermsOfPaymentByType(0);
      setTermsOfPayment(terms);
    };
    fetchTerms();

    let defaultValues = {};
    defaultValues.caseId = caseId;
    defaultValues.termsOfPaymentId = termsOfPayment1?.id;
    defaultValues.type = 0;

    reset({ ...defaultValues });
  }, [caseId, reset, termsOfPayment1]);

  const submitCaseTermsOfPayment = async (values) => {
    const response = await updateCaseTermsOfPayment(
      values.caseId,
      values.termsOfPaymentId,
      values.type
    );
    await getCaseData();
    handleCloseUpdateCaseTermsOfPayment();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdateCaseTermsOfPayment}
        onClose={handleCloseUpdateCaseTermsOfPayment}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Terms of Payment Before Design</DialogTitle>
        <form onSubmit={handleSubmit(submitCaseTermsOfPayment)}>
          <DialogContent dividers>
            <Grid container spacing={1}>
              <Grid item xs={7}>
                <Controller
                  control={control}
                  name="termsOfPaymentId"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <Autocomplete
                      options={termsOfPayment}
                      defaultValue={termsOfPayment1?.name}
                      onChange={(_, val) => {
                        onChange(val?.id || "");
                      }}
                      getOptionLabel={(option) => option.name || option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(error)}
                          FormHelperTextProps={{ variant: "standard" }}
                          helperText={error && error.message}
                          placeholder="Terms of Payment Before Design"
                        />
                      )}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        );
                      }}
                      sx={{ width: "100%" }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              onClick={handleCloseUpdateCaseTermsOfPayment}
              disabled={isSubmitting}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateCaseTermsOfPaymentDialog;
